import React, { useState, useRef, useEffect } from "react";
import Select from "react-select";
import { customSelectStyles } from "../utils/styles";
import monsterVisual_en from "../data/en/NPC Monsters (Spawnable).json";
import monsterVisual_vi from "../data/vi/NPC Monsters (Spawnable).json";
import { useTranslation } from "react-i18next";
import pkg from "../../package.json";

const webCommandAPI = pkg["web-command-api"];

function HandleSpawn() {
  const [selectedMonsterOption] = useState([]);
  const [selectedMonsterVisualOption, setSelectedMonsterVisualOption] =
    useState([]);
  const [level, setLevel] = useState(1);
  const [isExecuting, setIsExecuting] = useState(false);
  const [showNotification, setShowNotification] = useState(false);
  const [quantity, setQuantity] = useState(1);
  const { t, i18n } = useTranslation();
  const currentLanguage = i18n.language;

  const [monsterVisualData, setMonsterVisualData] = useState([]);

  // Fetch scene data
  useEffect(() => {
    const fetchSceneData = async () => {
      const url =
        currentLanguage === "vi"
          ? "https://raw.githubusercontent.com/arimetson/hotarusr-web-data/refs/heads/main/data/vi/NPC Monsters (Spawnable).json"
          : "https://raw.githubusercontent.com/arimetson/hotarusr-web-data/refs/heads/main/data/en/NPC Monsters (Spawnable).json";

      try {
        const res = await fetch(url);
        if (!res.ok) throw new Error("Network response was not ok");
        const json = await res.json();
        setMonsterVisualData(json);
      } catch (error) {
        // Fallback to local data
        setMonsterVisualData(currentLanguage === "vi" ? monsterVisual_vi : monsterVisual_en);
      }
    };

    fetchSceneData();
  }, [currentLanguage]);

  const handleSelectMonsterVisualChange = (selectedMonsterVisualOption) => {
    setSelectedMonsterVisualOption(selectedMonsterVisualOption);
  };

  const handleLevelChange = (value) => {
    let newValue = parseInt(value);
    if (isNaN(newValue) || newValue < 1) {
      newValue = 1;
    } else if (newValue > 95) {
      newValue = 95;
    }
    setLevel(newValue);
  };

  const handleQuantityChange = (value) => {
    let newValue = parseInt(value);
    if (isNaN(newValue) || newValue < 1) {
      newValue = 1;
    }
    setQuantity(newValue);
  };

  const inputRef3 = useRef(null);
  const handleInputClick3 = () => {
    if (inputRef3.current) {
      inputRef3.current.select();
      document.execCommand("copy");
      setShowNotification(true);
      setTimeout(() => {
        setShowNotification(false);
      }, 2000); // Hide notification after 2 seconds
    }
  };

  const handleFocusAndClick = (e) => {
    e.target.select();
  };

  // Hàm xử lý nút Execute
  const handleExecute = () => {
    if (isExecuting) return;
    setIsExecuting(true);

    try {
      const savedKey = sessionStorage.getItem("playerKey");
      if (!savedKey) return;

      if (!selectedMonsterOption) return;
      if (!selectedMonsterVisualOption) return;

      let commandValue = `/spawn ${selectedMonsterVisualOption.value} s${selectedMonsterOption.value} lv${level} x${quantity}`;
      if (commandValue.startsWith("/")) {
        commandValue = commandValue.substring(1);
      }

      const encodedCommand = encodeURIComponent(commandValue);
      const url = `${webCommandAPI}/excute/${savedKey}/${encodedCommand}`;

      fetch(url, { mode: "no-cors" })
        .then((res) => res.text())
        .catch(() => { });
    } catch (_) { }

    setTimeout(() => {
      setIsExecuting(false);
    }, 5000);
  };

  return (
    <>
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-3">
            <h2 className="title">{t("spawn")}</h2>
          </div>
          <div className="col-sm-8" />
        </div>
      </div>
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-10">
            <div
              className="outdated-message"
              dangerouslySetInnerHTML={{ __html: t("beta-warning-message") }}
            />
          </div>
          <div className="col-sm-1"></div>
        </div>
      </div>
      <br />
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-2">
            <h5 className="name-of-selection">{t("enemy-name")}</h5>
          </div>
          <div className="col-sm-6">
            <Select styles={customSelectStyles}
              className="select"
              value={selectedMonsterVisualOption}
              onChange={handleSelectMonsterVisualChange}
              options={monsterVisualData.map((monsterVisual) => ({
                value: monsterVisual.id,
                label: monsterVisual.name,
              }))}
            />
          </div>
          <div className="col-sm-3" />
        </div>
      </div>
      <br />
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-2">
            <h5 className="name-of-selection">{t("level")}</h5>
          </div>
          <div className="col-sm-6">
            <input
              type="number"
              value={level}
              onChange={(e) => handleLevelChange(e.target.value)}
              min={1}
              max={95}
              className="glass-input"
              onClick={handleFocusAndClick}
              onFocus={handleFocusAndClick}
            />
          </div>
          <div className="col-sm-3" />
        </div>
      </div>
      <br />
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-2">
            <h5 className="name-of-selection">{t("quantity")}</h5>
          </div>
          <div className="col-sm-6">
            <input
              type="number"
              value={quantity}
              onChange={(e) => handleQuantityChange(e.target.value)}
              className="glass-input"
              onClick={handleFocusAndClick}
              onFocus={handleFocusAndClick}
            />
          </div>
          <div className="col-sm-3" />
        </div>
      </div>
      <br />
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-2">
            <h2 className="final-command">{t("command")}</h2>
          </div>
          <div className="col-sm-9" />
        </div>
      </div>
      <div className="body">
        <div className="row">
          <div className="col-sm-1" />
          <div className="col-sm-6">
            {selectedMonsterOption && selectedMonsterVisualOption && (
              <input
                type="text"
                value={`/spawn ${selectedMonsterVisualOption.value} ${selectedMonsterVisualOption.value} lv${level} x${quantity}`}
                readOnly
                ref={inputRef3}
                className="glass-input"
                onClick={handleInputClick3}
              />
            )}
          </div>
          {selectedMonsterOption && selectedMonsterVisualOption && (
            <div className="col-sm-2">
              <button
                className="glass-button-primary w-full"
                onClick={handleExecute}
                disabled={isExecuting}
              >
                {isExecuting ? "Executing..." : "Execute"}
              </button>
            </div>
          )}
          <div className="col-sm-5" />
        </div>
      </div>
      <br />
      {showNotification && (
        <div className="notification">{t("copySuccess")}</div>
      )}
      <div style={{ marginTop: "100px" }} />
    </>
  );
}

export default HandleSpawn;
